// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pw-c";
export var backButton = "_pw-4";
export var backIcon = "_pw-5";
export var chevronShortcut = "_pw-6";
export var container = "_pw-1";
export var editor = "_pw-8";
export var editorWrapper = "_pw-7";
export var prefix = "_pw-2";
export var searchIcon = "_pw-3";
export var suffix = "_pw-9";
export var suffixContent = "_pw-a";
export var suffixText = "_pw-b";
export var wrapper = "_pw-0";